import React from "react";

// Matches URLs with protocol OR bare domains with common TLDs (optionally followed by a path)
const URL_REGEX = /(https?:\/\/[^\s<>"')\]},;]+|(?:[\w-]+\.)+(?:com|net|org|edu|gov|io|co|au|nz|uk|app|dev|me|info)(?:\.au)?(?:\/[^\s<>"')\]},;]*)?)/gi;

const linkifyText = (text) => {
  if (!text || typeof text !== "string") return text;

  const parts = text.split(URL_REGEX);
  if (parts.length === 1) return text;

  return parts.map((part, i) => {
    // Reset lastIndex since we reuse the global regex
    URL_REGEX.lastIndex = 0;
    if (URL_REGEX.test(part)) {
      const href = part.match(/^https?:\/\//) ? part : `https://${part}`;
      return (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="underline break-all hover:opacity-80"
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

export default linkifyText;
